<div class="empty-state">
  <div class="mat-headline-4 parking-lot-setup-title">Park calls with OnSIP</div>
  <div class="mat-body-2 parking-lot-setup-text">
    Call parking allows you to transfer a call to a parking lot, where it can be retrieved from any
    device on your OnSIP-hosted PBX.
  </div>

  <button
    mat-flat-button
    [attr.data-cy]="e2Locator"
    color="primary"
    type="button"
    [routerLink]="viewsLink"
  >
    <span translate [translateParams]="{ value: 'parking lot' }"> ONSIP_I18N.SET_UP_VALUE </span>
  </button>

  <div class="mat-body-2 parking-lot-pricing">
    {{ pricingText }}
  </div>
</div>
